import * as React from 'react';
import styled from 'styled-components';

import Box from '../box';
import {
	useCustomTheme,
	makeFullWidth,
	makeBoxShadows,
} from '../../styles';
import { CardProps } from './card';


type RootProps = {} & CardProps;

const Root = styled(({
	elevation,
	hoverElevation,
	appearance,
	fullWidth,
	isActive,
	beyondContainerWhenActive,
	...rest }) => <Box {...rest} />)<RootProps>`
	position: relative;
	display: inline-block;
	height: auto;
	transition: box-shadow .2s ease-in-out;
	${p => makeFullWidth(p)}
	${p => makeBoxShadows(p.elevation)}

	&:hover {
		${(p: RootProps) => makeBoxShadows(p.hoverElevation)}
		z-index: 1;
	}

	${(p: RootProps) => `
		background-color: ${p.bg === 'stealthy' ? '#fcfcfc' : useCustomTheme(p)[0].palette.whitePrimary};
		color: ${useCustomTheme(p)[0].palette.blackPrimary};
	`}

	${(p: RootProps) => p.appearance === 'repeater-item' && `
		padding: 12px 20px;
		border: 1px solid ${useCustomTheme(p)[0].palette.blackStealthy};
		margin-top: -1px;
	`}

	${(p: RootProps) => p.isActive && `
		${makeBoxShadows(4)}
		border-color: ${useCustomTheme(p)[0].palette.accentPrimary};
		z-index: 2;
	`}

	${(p: RootProps) => p.isActive && p.beyondContainerWhenActive && p.fullWidth &&`
		width: calc(100% + 20px);
		margin: 0 -10px;
	`}
`;

export {
	Root
}
